import { render } from "./ConversationList.vue?vue&type=template&id=260b2822"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"
script.render = render

export default script